import { comments, relatedTerms } from "@/mocks/eventArchive";

export default function CommunitySection() {
  return (
    <section id="taolun" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>评论区氛围
            </span>
            <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              高赞都站「别急着站队」
            </h2>
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-2 text-sm font-medium text-accent-900">
            <i className="ri-heart-3-fill"></i>本区氛围提示：理性讨论 · 不人身攻击
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          {/* 左侧：拟发表框 + 高赞 */}
          <div className="space-y-6 lg:col-span-3">
            {/* 拟评论输入（静态展示） */}
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                  我
                </span>
                <div className="flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-400">
                  说点有依据的看法，和大家一起理清时间线……
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3">
                <div className="flex items-center gap-1 text-foreground-500">
                  <i className="ri-emotion-happy-line p-2 hover:text-primary-600"></i>
                  <i className="ri-image-line p-2 hover:text-primary-600"></i>
                  <i className="ri-at-line p-2 hover:text-primary-600"></i>
                </div>
                <div className="flex items-center gap-2">
                  <span className="hidden text-xs text-foreground-500 sm:inline">文明发言 · 引用要标出处</span>
                  <button
                    type="button"
                    className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 whitespace-nowrap"
                  >
                    发布评论
                  </button>
                </div>
              </div>
            </div>

            {/* 高赞评论 */}
            <div className="space-y-4">
              {comments.map((c) => (
                <article key={c.handle} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-800">
                        {c.handle.slice(0, 1)}
                      </span>
                      <div className="leading-tight">
                        <p className="text-sm font-semibold text-foreground-950">{c.handle}</p>
                        <p className="text-xs text-foreground-500">{c.time}</p>
                      </div>
                    </div>
                    <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900 whitespace-nowrap">
                      {c.tag}
                    </span>
                  </div>
                  <p className="mt-4 text-sm leading-7 text-foreground-800">{c.text}</p>
                  <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-foreground-500">
                    <span className="inline-flex items-center gap-1.5 text-xs hover:text-primary-600">
                      <i className="ri-thumb-up-line"></i>{c.like}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs hover:text-primary-600">
                      <i className="ri-chat-1-line"></i>回复
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs hover:text-primary-600">
                      <i className="ri-share-line"></i>转发
                    </span>
                  </div>
                </article>
              ))}
            </div>

            <button
              type="button"
              className="w-full rounded-lg border border-dashed border-background-300 bg-background-50 py-3 text-sm font-medium text-foreground-600 hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
            >
              查看更多讨论<i className="ri-arrow-down-s-line ml-1"></i>
            </button>
          </div>

          {/* 右侧：相关阅读 */}
          <aside className="lg:col-span-2">
            <div className="sticky top-24 space-y-5">
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h4 className="font-head-cn text-lg font-bold text-foreground-950">相关关键词</h4>
                <p className="mt-1 text-xs text-foreground-500">顺着这些词能最快找到同类汇总帖</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {relatedTerms.map((t) => (
                    <a
                      key={t}
                      href="#shijianxian"
                      className="inline-flex items-center rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-sm text-foreground-800 transition-colors hover:border-accent-400 hover:bg-accent-100 hover:text-accent-900 whitespace-nowrap"
                    >
                      #{t}
                    </a>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-accent-300 bg-accent-100 p-6">
                <div className="flex items-center gap-2 text-accent-900">
                  <i className="ri-lightbulb-flash-line text-xl"></i>
                  <h4 className="font-head-cn text-lg font-bold">围观提示</h4>
                </div>
                <ul className="mt-3 space-y-2.5 text-sm leading-6 text-accent-950">
                  <li className="flex gap-2"><span className="text-accent-700">·</span>先看疑点清单，再看双方长文，别反着来。</li>
                  <li className="flex gap-2"><span className="text-accent-700">·</span>截图可信度大致排序：本人原帖 &gt; 转载 &gt; 匿名。</li>
                  <li className="flex gap-2"><span className="text-accent-700">·</span>「时间对应关系」永远比情绪更接近真相。</li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}